<!-- Loading bar -->
@if (loading) {
    <mat-progress-bar class="absolute inset-x-0 top-0 h-0.5" [mode]="'indeterminate'">
    </mat-progress-bar>
}
<!-- Content -->
<div class="flex flex-col flex-auto h-full overflow-hidden bg-card dark:bg-default">

    <!-- Header -->
    <div class="z-10 relative flex flex-row items-center flex-0 w-full border-b bg-gray-100 dark:bg-transparent">

        <!-- Title -->
        <div class="px-6 py-2 text-3xl font-semibold tracking-tight w-1/2">
            {{ 'services.migration.title' | transloco }}
        </div>

        <!-- Action buttons -->
        <div class="flex flex-col flex-auto items-end justify-center">

        </div>
    </div>

    <!-- Table container -->
    <div class="flex flex-col 2xl:flex-1 2xl:max-h-full flex-0 h-full
        overflow-hidden bg-gray-100 dark:bg-transparent" fuseScrollReset>

        <!-- Table actions -->
        <div class="flex flex-row items-center justify-end py-2 px-4">
            @if (!destinationView && role?.adminMeAndChildren) {
                <button class="ml-2" mat-flat-button color="accent" [disabled]="selection.hasValue()" (click)="fileInput.click()">
                    <input #fileInput hidden="true" type="file" onclick="this.value=null" (change)="import($event)" />
                    {{ 'services.migration.import' | transloco }}
                </button>
            }
            @if (!destinationView && role?.adminMeAndChildren) {
                <button class="ml-2" mat-flat-button color="accent" [disabled]="!selection.hasValue()" (click)="export()">
                    {{ 'services.migration.export' | transloco }}
                </button>
            }
            @if (!destinationView && role?.dataVerifier) {
                <button class="ml-2" mat-flat-button color="primary" [disabled]="!selection.hasValue()" (click)="destinationView = true">
                    {{ 'services.migration.destiny' | transloco }}
                </button>
            }
            @if (destinationView && role?.dataVerifier) {
                <button class="ml-2" mat-flat-button color="primary" [disabled]="!destinationView" (click)="destinationView = false">
                    {{ 'back' | transloco }}
                </button>
            }
            @if (destinationView && role?.dataVerifier) {
                <button class="ml-2" mat-flat-button color="primary" [disabled]="!selection.hasValue() || !destinySelection.hasValue()" (click)="migrate()">
                    {{ 'services.migration.migrate' | transloco }}
                </button>
            }
        </div>

        <!-- Table -->
        <div class="flex flex-col mb-10 pb-6 overflow-y-auto">

            @if (!destinationView) {
                <!-- Header -->
                <div class="flex flex-row gap-4 sticky top-0 px-6 py-4 text-md font-semibold text-secondary
                    shadow bg-gray-50 dark:bg-slate-900 md:px-8">
                    <!-- Checkbox column -->
                    <div class="flex-auto w-16">
                        <mat-checkbox (change)="$event ? toggleAllRows() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
                        @if (selection.hasValue() && selection.selected.length > 0) {
                            <p>({{ selection.selected.length }})</p>
                        }
                    </div>
                    <div class="flex-auto w-64">
                        {{ 'name' | transloco }}
                    </div>
                    <!-- <div class="flex-auto w-64">
                        {{ 'services.migration.owner' | transloco }}
                    </div> -->
                    <div class="flex-auto w-32">
                        {{ 'services.migration.type' | transloco }}
                    </div>
                    <div class="flex-auto w-32">
                        {{ 'services.migration.typology' | transloco }}
                    </div>
                </div>

                @for (item of migrationItems; track item) {
                    <div class="flex flex-row gap-4 items-center px-6 py-3
                        border-b md:px-8">
                        <!-- Checkbox -->
                        <div class="flex-auto w-16">
                            <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(item) : null"
                                [checked]="selection.isSelected(item)">
                            </mat-checkbox>
                        </div>
                        <div class="flex flex-row flex-auto w-64 items-center">
                            {{ item.name }}
                        </div>
                        <!-- <div class="flex-auto w-64">
                            {{ item.ownerName }}
                        </div> -->
                        <div class="flex-auto w-32">
                            {{ getTypeCaption(item) }}
                        </div>
                        <div class="flex-auto w-32">
                            {{ item.masterType }}
                        </div>
                    </div>
                } @empty {
                    <div class="flex justify-center font-semibold px-6 py-8 md:px-8">
                        {{ 'services.migration.noItems' | transloco }}
                    </div>
                }
            } @else {
                <!-- Header -->
                <div class="flex flex-row gap-4 sticky top-0 px-6 py-4 text-md font-semibold text-secondary
                    shadow bg-gray-50 dark:bg-slate-900 md:px-8">
                    <!-- Checkbox column -->
                    <div class="flex-auto w-16">
                        <mat-checkbox disabled [checked]="destinySelection.hasValue()"></mat-checkbox>
                        @if (destinySelection.hasValue() && destinySelection.selected.length > 0) {
                            <p>({{ destinySelection.selected.length }})</p>
                        }
                    </div>
                    <div class="flex-auto w-64">
                        {{ 'name' | transloco }}
                    </div>
                    <!-- <div class="flex-auto w-64">
                        {{ 'services.migration.owner' | transloco }}
                    </div> -->
                    <div class="flex-auto w-32">
                        {{ 'services.migration.type' | transloco }}
                    </div>
                    <div class="flex-auto w-32">
                        {{ 'services.migration.fullRoute' | transloco }}
                    </div>
                </div>

                @for (item of destinyItems; track item) {
                    <div class="flex flex-row gap-4 items-center px-6 py-3
                        border-b md:px-8">
                        <!-- Checkbox -->
                        <div class="flex-auto w-16">
                            <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? destinySelection.toggle(item) : null"
                                [checked]="destinySelection.isSelected(item)">
                            </mat-checkbox>
                        </div>
                        <div class="flex flex-row flex-auto w-64 items-center">
                            {{ item.name }}
                        </div>
                        <!-- <div class="flex-auto w-64">
                            {{ item.ownerName }}
                        </div> -->
                        <div class="flex-auto w-32">
                            {{ item.type }}
                        </div>
                        <div class="flex-auto w-32">
                            {{ item.fullRoute }}
                        </div>
                    </div>
                } @empty {
                    <div class="flex justify-center font-semibold px-6 py-8 md:px-8">
                        {{ 'services.migration.noDestinyItems' | transloco }}
                    </div>
                }
            }
        </div>
    </div>
</div>
